import type { CSSProperties, ReactNode } from 'react'

interface HeadsUpProps {
  title?: string
  children: ReactNode
  style?: CSSProperties
}

/**
 * Ochre △ callout for soft warnings.
 * Rule 08: lives separate from impact metrics — never inside AIPanel or CalcPanel.
 */
export function HeadsUp({ title, children, style }: HeadsUpProps): JSX.Element {
  return (
    <div
      data-testid="heads-up"
      role="note"
      style={{
        display: 'flex',
        gap: 10,
        alignItems: 'flex-start',
        padding: '10px 14px',
        background: 'var(--warning-bg)',
        border: '1px solid var(--warning-line)',
        borderRadius: 'var(--r-md)',
        fontSize: 13,
        color: 'var(--text)',
        lineHeight: 1.5,
        ...style,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          flexShrink: 0,
          color: 'var(--warning-fg)',
          fontWeight: 700,
          marginTop: 1,
        }}
      >
        △
      </span>
      <div>
        {title != null && (
          <strong style={{ fontWeight: 600 }}>{title} </strong>
        )}
        {children}
      </div>
    </div>
  )
}
